import styled, { css } from 'styled-components';
import { Content, Header } from 'antd/lib/layout/layout';
import { TitleProps } from 'antd/es/typography/Title';

export const StyledContent = styled(Content)`
    && {
        ${({ theme }) => css`
            background-color: ${theme.colors.white};
            max-width: 100vw;
            min-width: 0;
            overflow: hidden;
        `}
    }
`;

export const Title = styled.h2<TitleProps>`
    && {
        ${({ theme }) => css`
            font-weight: '0.2';
            color: ${theme.colors.accentColor};
            font-size: ${theme.fontSizes.big};
            white-space: nowrap;
            margin: 0;
            margin-left: 40px;
        `}
    }
`;

export const WarningTextArea = styled.div`
    flex: 1;
    width: 100%;
    height: 50px;
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: red;
`;
